import { createAction, props } from '@ngrx/store';
import { ConvertedFile } from '../models/converted-file';
import { UploadedFile } from '../models/uploaded-file';
import { JobStatus } from '../models/job-status';

export const loadUploadedFiles = createAction('[Files] Load Uploaded Files');

export const loadUploadedFilesSuccess = createAction(
  '[Files] Load Uploaded Files Success',
  props<{ files: UploadedFile[] }>(),
);

export const loadGerberFiles = createAction('[Files] Load Gerber Files');

export const loadGerberFilesSuccess = createAction(
  '[GerberFiles] Load Gerber Files Success',
  props<{ gerberFiles: UploadedFile[] }>(),
);

export const loadLectraFiles = createAction('[Files] Load Lectra Files');

export const loadLectraFilesSuccess = createAction(
  '[LectraFiles] Load Lectra Files Success',
  props<{ lectraFiles: UploadedFile[] }>(),
);

export const loadConvertedFiles = createAction('[Files] Load Converted Files');

export const loadConvertedFilesSuccess = createAction(
  '[Files] Load Converted Files Success',
  props<{ files: ConvertedFile[] }>(),
);

export const addUploadedFile = createAction(
  '[Files] Add Uploaded File',
  props<{ file: UploadedFile }>(),
);

export const addGerberFile = createAction(
  '[GerberFiles] Add Gerber File',
  props<{ gerberFile: UploadedFile }>(),
);

export const addLectraFile = createAction(
  '[LectraFiles] Add Lectra File',
  props<{ lectraFile: UploadedFile }>(),
);

export const addConvertedFile = createAction(
  '[Files] Add Converted File',
  props<{ file: ConvertedFile }>(),
);

export const moveFileToEndOfQueue = createAction(
  '[Home] Move File To End Of Queue',
  props<{ fileId: string }>(),
);

export const moveFileToEndOfGerberQueue = createAction(
  '[GerberFiles] Move File To End Of Gerber Queue',
  props<{ fileId: string }>(),
);

export const moveFileToEndOfLectraQueue = createAction(
  '[LectraFiles] Move File To End Of Lectra Queue',
  props<{ fileId: string }>(),
);

export const updateUploadedFileStatus = createAction(
  '[Files] Update Uploaded File Status',
  props<{ fileId: string; status: JobStatus; queuePosition: number }>(),
);

export const updateGerberFileStatus = createAction(
  '[GerberFiles] Update Gerber File Status',
  props<{ fileId: string; status: JobStatus }>(),
);

export const updateLectraFileStatus = createAction(
  '[LectraFiles] Update Lectra File Status',
  props<{ fileId: string; status: JobStatus }>(),
);

export const reorderUploadedFiles = createAction(
  '[UploadedFiles] Reorder Files',
  props<{ previousIndex: number; currentIndex: number }>(),
);

export const reorderGerberFiles = createAction(
  '[GerberFiles] Reorder Gerber Files',
  props<{ previousIndex: number; currentIndex: number }>(),
);

export const reorderLectraFiles = createAction(
  '[LectraFiles] Reorder Lectra Files',
  props<{ previousIndex: number; currentIndex: number }>(),
);

export const resetFileStatus = createAction(
  '[UploadedFiles] Reset File Status',
);

export const resetGerberFileStatus = createAction(
  '[GerberFiles] Reset Gerber File Status',
);

export const resetLectraFileStatus = createAction(
  '[LectraFiles] Reset Gerber File Status',
);

export const deleteUploadedFile = createAction(
  '[Home] Delete Uploaded File',
  props<{ fileId: string }>(),
);

export const deleteGerberFile = createAction(
  '[GerberFiles] Delete Gerber File',
  props<{ fileId: string }>(),
);

export const deleteLectraFile = createAction(
  '[LectraFiles] Delete Lectra File',
  props<{ fileId: string }>(),
);

export const conversionComplete = createAction(
  '[Home] Conversion Complete',
  props<{ fileId: string }>(),
);

export const gerberConversionComplete = createAction(
  '[GerberFiles] Gerber Conversion Complete',
  props<{ fileId: string }>(),
);

export const lectraConversionComplete = createAction(
  '[LectraFiles] Lectra Conversion Complete',
  props<{ fileId: string }>(),
);

export const clearHomeState = createAction('[Home] Clear State');

export const clearFileQueue = createAction('[Home] Clear File Queue');

export const clearGerberFileQueue = createAction(
  '[GerberFiles] Clear Gerber File Queue',
);

export const clearLectraFileQueue = createAction(
  '[LectraFiles] Clear Lectra File Queue',
);

export const requestClearConvertedFiles = createAction(
  '[Home] Request Clear Converted Files',
);

export const clearConvertedFiles = createAction('[Home] Clear Converted Files');

export const deleteConvertedFile = createAction(
  '[Home] Delete Converted File',
  props<{ fileId: string }>(),
);
export const deleteConvertedFileSuccess = createAction(
  '[Home] Delete Converted File Success',
  props<{ fileId: string }>(),
);

export const deleteConvertedFileFailure = createAction(
  '[Home] Delete Converted File Failure',
  props<{ error: any }>(),
);
export const lockFileBox = createAction('[Home] Lock FileBox');
export const lockGerber = createAction('[GerberFiles] Lock Gerber');
export const lockLectra = createAction('[LectraFiles] Lock Lectra');
export const unlockFileBox = createAction('[Home] Unlock FileBox');
export const unlockGerber = createAction('[GerberFiles] Unlock Gerber');
export const unlockLectra = createAction('[LectraFiles] Unlock Lectra');
export const resetAllFiles = createAction('[Home] Reset All Files');
export const resetAllGerberFiles = createAction(
  '[GerberFiles] Reset All Gerber Files',
);
export const resetAllLectraFiles = createAction(
  '[LectraFiles] Reset All Lectra Files',
);
export const loadMonthlyConvertedFiles = createAction(
  '[Home] Load Monthly Converted Files',
);
export const loadMonthlyConvertedFilesSuccess = createAction(
  '[Home] Load Monthly Converted Files Success',
  props<{ files: { count: number } }>(),
);
export const loadMonthlyConvertedFilesError = createAction(
  '[Home] Load Monthly Converted Files Failure',
  props<{ error: string }>(),
);
